import { TrendingUp } from "lucide-react";
import { STATES_TICKER } from "@/config/clinicConfig";

function Track() {
  return (
    <div className="flex shrink-0 items-center">
      {STATES_TICKER.states.map((s, i) => (
        <span
          key={s}
          data-testid={`state-ticker-item-${i}`}
          className="mx-6 flex items-center gap-2.5 font-mono text-sm uppercase tracking-[0.2em] text-espresso sm:text-base"
        >
          <TrendingUp size={17} className="text-clay" />
          {s}
          <span className="ml-3.5 h-1.5 w-1.5 rounded-full bg-gold/70" />
        </span>
      ))}
    </div>
  );
}

export default function StatesTicker() {
  return (
    <section data-testid="states-ticker" className="border-y border-espresso/10 bg-sand py-7">
      <p className="mb-5 px-5 text-center font-mono text-[13px] font-semibold uppercase tracking-[0.22em] text-espresso sm:text-sm">
        <span className="mr-2 inline-block h-1.5 w-1.5 rounded-full bg-clay align-middle" />
        {STATES_TICKER.label}
      </p>
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          <Track />
          <Track />
        </div>
      </div>
    </section>
  );
}
